import { defineMessages } from 'react-intl';

const messages = defineMessages({
  openActionsMenu: {
    defaultMessage: 'open actions menu',
    id: '8EZ5R2',
    description: 'aria label for the provider actions menu',
  },
});

export default messages;
